import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import {Folder} from 'lucide-react-native';
import {AppDataMediaItem} from "@/data/app-data-interfaces";
import {useCurrentTheme} from "@/theming/useCurrentTheme";
import {ThemeType} from "@/theming/baseTheme";
import {FolderBreadcrumb} from "@/components/media/FolderBreadcrumb";

interface VideoInfoProps {
    video: AppDataMediaItem;
    orgId: string;
}

export const VideoHeader: React.FC<VideoInfoProps> = ({video, orgId}) => {
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme);

    return (
        <View style={styles.videoInfo}>
            <Text style={styles.videoTitle}>{video.name}</Text>

            <View style={styles.videoMeta}>
                <View style={styles.videoType}>
                    <Text style={styles.videoTypeText}>{video.type.toUpperCase()}</Text>
                </View>
                <View style={styles.metaItem}>
                    <Folder size={12} color={theme.colors.textSecondary} style={styles.metaIcon}/>
                    <FolderBreadcrumb folderId={video.folderId} orgId={orgId} />
                </View>
            </View>
        </View>
    );
};

const createStyles = (theme: ThemeType) => StyleSheet.create({
    videoInfo: {
        paddingTop: 20,
    },
    videoTitle: {
        fontSize: 22,
        fontWeight: '700',
        color: theme.colors.text,
        marginBottom: 8,
        lineHeight: 28,
    },
    videoMeta: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 16,
        flexWrap: 'wrap',
    },
    videoType: {
        backgroundColor: theme.colors.primary,
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: 12,
        marginRight: 16,
    },
    videoTypeText: {
        color: '#000',
        fontSize: 11,
        fontWeight: '600',
    },
    metaItem: {
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 16,
    },
    metaIcon: {
        marginRight: 4,
    },
    metaText: {
        fontSize: 14,
        color: theme.colors.textSecondary,
    }
});
